import React from "react";
import { IoMdMail } from "react-icons/io";
import { useInView } from "react-intersection-observer";
import { NavLink } from "react-router-dom";

const ManagementCard = ({ profile, index }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div
      ref={ref}
      className={`w-full max-w-xs   p-6 rounded-2xl group ${
        inView
          ? `lg:animate-slideUp ${
              index % 2 === 0 ? "animate-slideRight" : "animate-slideLeft"
            }`
          : "opacity-0"
      } bg-[#DEE9E4] hover:bg-[#00643b]  `}
    >
      <img
        src={profile?.profileImage?.imageUrl}
        className="rounded-xl w-full object-cover aspect-[1/1.2] "
        alt=""
      />
      <div className="mt-8 text-center relative">
        {profile?.email && (
          <a
            href={`mailto:${profile.email}`}
            className="absolute bg-[#00643b] group-hover:bg-[#fff] py-1.5 px-5 rounded-full text-white group-hover:text-[#00643b] top-[-48px] left-1/2 transform -translate-x-1/2 transition-all duration-300"
          >
            <IoMdMail className="size-5" />
          </a>
        )}
        <h1 className="text-[1.1rem] font-semibold group-hover:text-white">
          {profile.fullName}
        </h1>
        <p className="text-[.9rem] text-[#343434] group-hover:text-white font-semibold">
          {profile?.position}
        </p>
      </div>
    </div>
  );
};

export default ManagementCard;
